'use client';

import { useState, useEffect } from 'react';

interface Section {
  id: string;
  label: string;
}

const SectionProgressIndicator = () => {
  const [activeSection, setActiveSection] = useState('');
  const [scrollProgress, setScrollProgress] = useState(0);

  const sections: Section[] = [
    { id: 'hero', label: 'Start' },
    { id: 'business-services', label: 'Biznes' },
    { id: 'personal-financing', label: 'Osobiste' },
    { id: 'calculator', label: 'Kalkulator' },
    { id: 'about', label: 'O Nas' },
    { id: 'contact', label: 'Kontakt' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;
      setScrollProgress(scrollPercentage);

      const sectionElements = sections.map(section => ({
        id: section.id,
        element: document.getElementById(section.id),
      }));

      const scrollPosition = window.scrollY + 150;

      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const section = sectionElements[i];
        if (section.element && section.element.offsetTop <= scrollPosition) {
          setActiveSection(section.id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSectionClick = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetPosition = element.offsetTop - 80;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="hidden lg:block fixed right-8 top-1/2 -translate-y-1/2 z-30 pointer-events-none">
      <div className="relative">
        <div className="absolute left-1/2 -translate-x-1/2 w-0.5 h-full bg-border" />
        <div
          className="absolute left-1/2 -translate-x-1/2 w-0.5 bg-primary transition-all duration-250"
          style={{ height: `${scrollProgress}%` }}
        />

        <div className="relative flex flex-col gap-6">
          {sections.map((section, index) => (
            <button
              key={section.id}
              onClick={() => handleSectionClick(section.id)}
              className="group relative flex items-center justify-center pointer-events-auto"
              aria-label={`Przejdź do sekcji ${section.label}`}
            >
              <div
                className={`w-3 h-3 rounded-full border-2 transition-all duration-250 ${
                  activeSection === section.id
                    ? 'bg-primary border-primary scale-125' :'bg-card border-border group-hover:border-primary group-hover:scale-110'
                }`}
              />

              <div
                className="absolute right-6 px-3 py-1.5 bg-card border border-border rounded-lg shadow-card opacity-0 group-hover:opacity-100 transition-opacity duration-250 whitespace-nowrap pointer-events-none"
              >
                <span className="text-xs font-body font-medium text-foreground">
                  {section.label}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionProgressIndicator;